<mat-expansion-panel class="product mat-typography mat-elevation-z0" [ngClass.xs]="{ selected: hasSelection(product) }"
  [ngClass.gt-xs]="{ desktop: true, selected: hasSelection(product) }" [expanded]="expandAll$ | async"
  (opened)="panelChanged()" (closed)="panelChanged(false)" hideToggle *ngIf="product$ | async as product">

  <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
    <mat-panel-title [innerHTML]="product.name | highlight:(filterService.filterQuery$ | async)"></mat-panel-title>
    <mat-panel-description>
      <span>{{totalVolume$ | async | number: '1.3-3' }} {{ 'UNITS.VOLUME_METERS_CUBE' | translate }}</span>
      <span>{{product.packages.length }} {{ 'UNITS.AMOUNT_PACKAGES' | translate }}</span>
      <span class="fill-remaining-space"></span>
      <mat-icon *ngIf="!opened" svgIcon="toggle"></mat-icon>
      <mat-icon *ngIf="opened" svgIcon="green-toggle" [ngClass]="'rotate'"></mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div *ngIf="mediaService.desktop$ | async; else listView">
      <app-package-list-table [product$]="product$" [readOnly]="readOnly" [cart]="cart" [internalUser]="userApiService.isInternalUser$ | async" [currency]="currency" [locale]="locale"
        [@.disabled]="true"></app-package-list-table>
    </div>
    <ng-template #listView>
      <app-package-list [product$]="product$" [readOnly]="readOnly" [cart]="cart" [internalUser]="userApiService.isInternalUser$ | async" [currency]="currency" [locale]="locale"
        [@.disabled]="true"></app-package-list>
    </ng-template>
  </ng-template>
</mat-expansion-panel>
